import PropTypes from 'prop-types';
import viLocale from 'date-fns/locale/vi';
// @mui
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// hooks
import useLocales from '../hooks/useLocales';

// ----------------------------------------------------------------------

// Custom weeks day
// const weekDaysVi = ['Th2', 'Th3', 'Th4', 'Th5', 'Th6', 'Th7', 'CN'];
// const weekDaysEn = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// class CustomDateFnsAdapter extends AdapterDateFns {
//   // const getWeekdays = () => {
//   //   return weekDaysVi;
//   // }
// }
// CustomDateFnsAdapter.prototype.getWeekdays = () => {
//   return weekDaysVi;
// }
//

DateLocalization.propTypes = {
  children: PropTypes.node,
};

export default function DateLocalization({ children }) {
  const { currentLang } = useLocales();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={currentLang?.value === 'vi' ? viLocale : undefined}
    >
      {children}
    </LocalizationProvider>
  );
}
